import { Outlet } from 'react-router-dom';

import RestrictedAccess from '@dmp/components/ui/RestrictedAccess/RestrictedAccess';
import { getCachedUserInfo } from '@dmp/utils';
import { getInternalAppsPermission, isCentificUser } from '@dmp/utils/rbac';

const NoPermission = <RestrictedAccess />;

export const AgencyCatalogGuard = () => {
  if (isCentificUser(getCachedUserInfo()?.user_email)) {
    return <Outlet />;
  } else {
    return NoPermission;
  }
};

export const AgencyCatalogAdminGuard = () => {
  const internalAppsPermission = getInternalAppsPermission();

  if (!internalAppsPermission.agency_catalog) {
    return NoPermission;
  } else {
    return <Outlet />;
  }
};
